//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        emitCurrent: {
            type: String,
            default: 'show-current-residents'
        },
        emitPast: {
            type: String,
            default: 'show-past-residents'
        },
        emitReport: {
            type: String,
            default: 'show-report-residents'
        }
    },
    data: function data() {
        return {
            currentFilter: 'current'
        };
    },

    methods: {
        setList: function setList(type) {

            this.currentFilter = type;

            Event.$emit('type');

            // Emit tab to show
            Event.$emit(type == 'past' ? this.emitPast : type == 'current' ? this.emitCurrent : this.emitReport);

            // Emit refresh
            Event.$emit(type == 'past' ? 'past-resident-list-updated' : 'show-resident-list');
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentListFilter.vue
// module id = 8Wfs
// module chunks = 0 1